import React, { Component } from 'react'
import ReactHighcharts from 'react-highcharts'

export default class MiniChart extends Component {
  constructor (props) {
    super(props)
    let data = props.data

    this.state = {
      lastUpdate: data[ data.length - 1 ][0]
    }

    this.config = {
      chart: { height: this.props.height || 350 },
      time: {
        useUTC: false,
        timezone: 'America/Bogota'
      },
      exporting: { enabled: false },
      scrollbar: { enabled: false },
      xAxis: {
        ordinal: false,
        type: 'datetime',
        dateTimeLabelFormats: {
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M'
        }
      },
      yAxis: {
        plotLines: [{
          value: this.props.max,
          color: '#f5222d',
          dashStyle: 'Solid',
          width: 2,
          label: {
            text: `${this.props.max} ${this.props.unit || ''}`
          }
        }, {
          value: this.props.min,
          color: '#a0d911',
          dashStyle: 'Solid',
          width: 2,
          label: {
            text: `${this.props.min} ${this.props.unit || ''}`
          }
        }],
        minRange: this.props.minrange || 10,
        title: { text: this.props.ylabel }
      },
      credits: {
        text: 'Innova',
        href: 'http://www.innovatecnologia.com/'
      },
      title: { text: this.props.title },
      series: [{
        showInLegend: false,
        type: this.props.type,
        color: this.props.color,
        data: this.props.data,
        zoneAxis: 'x',
        zones: [{
          value: this.state.lastUpdate
        }, {
          dashStyle: 'ShortDot'
        }],
        marker: {
          enabled: true,
          radius: 3
        },
        tooltip: {
          headerFormat: `${this.props.title} <b>{point.y} ${this.props.unit}</b> <br/>`,
          pointFormat: `{point.x:%e %b, %Y %H:%M:%S}`
        }
      }]
    }
  }

  componentDidMount () {
    this.chart = this.refs.chart.getChart()
  }

  componentWillReceiveProps ({ data }) {
    if (data[ data.length - 1 ][0] <= this.state.lastUpdate) return
    this.chart.series[0].addPoint(data[ data.length - 1 ], true, true)

    this.setState({ lastUpdate: data[ data.length - 1 ][0] })
  }

  shouldComponentUpdate () { return false }

  render () {
    return (
      <div ref='container'>
        <ReactHighcharts config={this.config} ref='chart' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/charts/MiniChart.js